__turbopack_context__.v({
  "bold": "OrderGrandTotal-module-scss-module__YC_E0q__bold",
  "container": "OrderGrandTotal-module-scss-module__YC_E0q__container",
  "rightContent": "OrderGrandTotal-module-scss-module__YC_E0q__rightContent",
  "separator": "OrderGrandTotal-module-scss-module__YC_E0q__separator",
  "totalItemsCount": "OrderGrandTotal-module-scss-module__YC_E0q__totalItemsCount",
});
